import React from 'react';
import { Button } from '../../../components/ui/Kit';
import {
  applicationTypeLabel,
  spouseFields,
  summarySections,
  summaryValue,
} from '../lib/fieldDefs';

export default function Step11Review({
  form,
  onEditFirst,
  onSubmit,
  submitting,
  onSaveDraft,
  savingDraft,
}) {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-gray-900">Review Summary</h2>

      {summarySections.map((section) => (
        <div key={section.title} className="rounded-lg border border-gray-200 p-4">
          <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-secondary">
            {section.title}
          </h3>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            {section.fields.map(([label, key]) => {
              if (key === 'other_specialists_detail' && form.other_specialists_5yr !== 'Yes') {
                return null;
              }
              return (
                <p key={key} className="text-sm text-gray-700">
                  <strong>{label}:</strong> {summaryValue(form[key])}
                </p>
              );
            })}
          </div>
        </div>
      ))}

      <div className="rounded-lg border border-gray-200 p-4">
        <h3 className="mb-2 text-sm font-semibold uppercase tracking-wide text-secondary">
          Beneficiaries
        </h3>
        {form.beneficiaries?.length ? (
          form.beneficiaries.map((entry, index) => (
            <p key={`review-beneficiary-${index}`} className="text-sm text-gray-700">
              <strong>#{index + 1}:</strong> {summaryValue(entry.full_name)} |{' '}
              {summaryValue(entry.relationship)} | {summaryValue(entry.percentage)}
            </p>
          ))
        ) : (
          <p className="text-sm text-gray-700">-</p>
        )}
      </div>

      <div className="rounded-lg border border-gray-200 p-4">
        <h3 className="mb-2 text-sm font-semibold uppercase tracking-wide text-secondary">
          Spouse
          {form.has_spouse && form.spouse_application_type
            ? ` (${applicationTypeLabel(form.spouse_application_type)})`
            : ''}
        </h3>
        <p className="mb-2 text-sm text-gray-700">
          <strong>Included:</strong> {form.has_spouse ? 'Yes' : 'No'}
        </p>
        {form.has_spouse && (
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            {spouseFields.map((key) => {
              if (
                key === 'spouse_other_specialists_detail' &&
                form.spouse_other_specialists_5yr !== 'Yes'
              ) {
                return null;
              }
              const label =
                key === 'spouse_application_type'
                  ? 'application type'
                  : key.replace(/_/g, ' ');
              const value =
                key === 'spouse_application_type'
                  ? applicationTypeLabel(form[key]) || '-'
                  : summaryValue(form[key]);
              return (
                <p key={key} className="text-sm text-gray-700">
                  <strong>{label}:</strong> {value}
                </p>
              );
            })}
          </div>
        )}
      </div>

      <div className="rounded-lg border border-gray-200 p-4">
        <h3 className="mb-2 text-sm font-semibold uppercase tracking-wide text-secondary">
          Children
        </h3>
        <p className="mb-2 text-sm text-gray-700">
          <strong>Included:</strong> {form.has_children ? 'Yes' : 'No'}
        </p>
        {form.has_children && form.children?.length > 0 ? (
          form.children.map((child, index) => (
            <p key={`review-child-${index}`} className="text-sm text-gray-700">
              <strong>#{index + 1}:</strong> {summaryValue(child.full_name)}
              {child.application_type
                ? ` (${applicationTypeLabel(child.application_type)})`
                : ''}{' '}
              | {summaryValue(child.dob)} | {summaryValue(child.gender)}
            </p>
          ))
        ) : (
          <p className="text-sm text-gray-700">-</p>
        )}
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <Button type="button" variant="outline" onClick={onEditFirst}>
          Edit
        </Button>
        {onSaveDraft ? (
          <Button
            type="button"
            variant="outline"
            onClick={onSaveDraft}
            disabled={savingDraft || submitting}
            isLoading={savingDraft}
          >
            {savingDraft ? 'Saving…' : 'Save Draft'}
          </Button>
        ) : null}
        <Button type="button" onClick={onSubmit} isLoading={submitting} disabled={submitting || savingDraft}>
          {submitting ? 'Submitting…' : 'Submit & Generate PDF'}
        </Button>
      </div>
    </div>
  );
}
